module.exports = __webpack_public_path__ + "static/img/login.bcbd12e.png";


//////////////////
// WEBPACK FOOTER
// ./static/login.png
// module id = /Fw+
// module chunks = 1